
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M13.1999 7.06998L10.2499 11L12.4999 14C12.8299 14.44 12.7399 15.07 12.2999 15.4C11.8599 15.73 11.2299 15.65 10.8999 15.2C9.84993 13.8 8.58993 12.13 7.79993 11.06C7.39993 10.53 6.59993 10.53 6.19993 11.06L2.19993 16.39C1.70993 17.06 2.17993 18 2.99993 18H20.9999C21.8199 18 22.2899 17.06 21.7999 16.4L14.7999 7.06998C14.3999 6.52998 13.5999 6.52998 13.1999 7.06998Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-filter-hdr`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconFilterHdr

    ```js
    <b-new-b-icon-filter-hdr />
    ```
</docs>


